import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TransportService } from 'src/app/private/services/transport.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-transport',
  imports: [SharedModule],
  templateUrl: './delete-transport.component.html',
  styleUrl: './delete-transport.component.scss'
})
export class DeleteTransportComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() transportData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: TransportService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {
    this.isLoading = true;

    const payload = {
      id: this.transportData.id,
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    }

    this.api.deleteTransport(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({
          severity: 'success', 
          summary: 'Success', 
          detail: 'Transport deleted successfully'
        });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to delete transport'
        });
        this.isLoading = false;
      }
    });
  }
}